import { Injectable, Type } from "@angular/core";

import {
  ClientMessageBrokerFactory,
} from "shared/provider-webworker";

import { ReplicaBlotterLookupService } from "../../impl/ReplicaBlotterLookupService";
import { IRiskTradePromiseLookupService } from "../IRiskTradePromiseLookupService";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class RiskTradeReplicaLookupService
  extends ReplicaBlotterLookupService<string, CubiqTS.DealImpl>
  implements IRiskTradePromiseLookupService
{
  constructor(protected factory: ClientMessageBrokerFactory) {
    super(factory, CubiqTS.DealImpl, "DealImpl", CubiqTS.DealImpl);
  }

  protected getModelUpdateEventType(): Type<CubiqTS.ConcreteEncodable> {
    return CubiqTS.DealImpl;
  }
}
